import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';

export interface Example {
	class?: string;
}

@Component({
	selector: 'bb-fitmode',
	templateUrl: './bb-fitmode.component.html',
	styleUrls: ['./bb-fitmode.component.scss']
})

export class BbFitmodeComponent implements OnInit {

	@Input() form: NgForm;
	@Input() screen: string;


	@Input()
	get entity() {
		return this._entity;
	}
	set entity(entity) {
		this._entity = entity;
		this.entityChange.emit(this._entity);
	}

	@Output() entityChange = new EventEmitter();

	fitmodes: string[];
	entityFitmode: string;
	examples: any[];
	entityDetails: {
		mediaType: string;
		mediaDescription: string;
	};

	private _entity: any;

	constructor(private translateService: TranslateService) {
		this.examples = [];
	}

	ngOnInit() {
		if (this.screen === 'mediaclipDetails') {
			this.fitmodes = ['none', 'smart', 'native', 'vertical', 'horizontal', 'both', 'stretch', 'overscan'];
		} else {
			this.fitmodes = ['smart_recommended', 'native', 'vertical', 'horizontal', 'both', 'stretch', 'overscan'];
		}

		this.fitmodes.forEach((fitmode: string) => {
			this.getFitmodeDimensions(fitmode);
		});

		if (this.entity) {
			this.entityFitmode = this.entity.fitmode;
			if (!this.entityFitmode) {
				this.entityFitmode = 'FIT_NONE';
			}
			if (this.entity.fitmode === 'FIT_SMART') {
				this.entityFitmode = 'FIT_SMART_RECOMMENDED';
			}
			if (this.entity.mediatype === 'video') {
				this.entityDetails = {
					mediaType: this.translateService.instant('VIDEO').toLowerCase(),
					mediaDescription: this.translateService.instant('VIDEO_FILE')
				};
			} else {
				this.entityDetails = {
					mediaType: this.translateService.instant('IMAGE').toLowerCase(),
					mediaDescription: this.translateService.instant('IMAGE_FILE')
				};
			}
		}
	}

	inputChanged(fitmode: string) {
		this.entity.fitmode = 'FIT_' + fitmode.toUpperCase();
		this.entity = this._entity;
		if (fitmode === 'smart_recommended') {
			this.entity.fitmode = 'FIT_SMART';
		}
	}

	getFitmodeDimensions(fitmode: string) {
		this.examples[fitmode] = [];

		switch (fitmode) {
			case 'native':
			case 'vertical':
			case 'horizontal':
				this.examples[fitmode].push({ class: 'background' });
				this.examples[fitmode].push({});
				break;
			case 'stretch':
			case 'both':
				this.examples[fitmode].push({});
				this.examples[fitmode].push({});
				break;
			case 'smart':
			case 'smart_recommended':
				this.examples[fitmode].push({});
				this.examples[fitmode].push({});
				this.examples[fitmode].push({});
				break;
			case 'overscan':
				this.examples[fitmode].push({ class: 'background' });
				this.examples[fitmode].push({ class: 'background' });
				break;
		}
	}
}
